import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const showOfficeLocationsState = atomWithStorage(
  'showOfficeLocationsState',
  true,
);

export const officeLocationsEditModeState = atom(false);
